import React from "react";

export const Services = (props) => {
  return (
    <div id="services" className="text-center">
      <div className="container">
        <div className="section-titles">
          <h2>Our Services</h2>
        </div>
        <div className="row">
          <div className="col-md-4">
            <i className="fa fa-list-alt"></i>
            <div className="service-desc">
              <h3>Bulk Construction Materials Supply</h3>
              <p>Get cement, steel, sand, and more directly from manufacturers.</p>
            </div>
          </div>
          <div className="col-md-4">
            <i className="fa fa-cogs"></i>
            <div className="service-desc">
              <h3>Heavy Machinery Leasing</h3>
              <p>Rent cranes, trucks, and other construction equipment with ease.</p>
            </div>
          </div>
          <div className="col-md-4">
            <i className="fa fa-tags"></i>
            <div className="service-desc">
              <h3>Manufacturer-Direct Pricing</h3>
              <p>No middlemen costs, ensuring maximum savings on every order.</p>
            </div>
          </div>
          <div className="col-md-4">
            <i className="fa fa-check-circle"></i>
            <div className="service-desc">
              <h3>Hassle-Free Procurement</h3>
              <p>From order to delivery, we handle the entire process for you.</p>
            </div>
          </div>
          <div className="col-md-4">
            <i className="fa fa-mobile"></i>
            <div className="service-desc">
              <h3>On-Site & App Ordering</h3>
              <p>Place orders easily via our website or app anytime, anywhere.</p>
            </div>
          </div>
          <div className="col-md-4">
            <i className="fa fa-truck"></i>
            <div className="service-desc">
              <h3>Quick & Reliable Delivery</h3>
              <p>Materials and machinery are delivered directly to your project site on time.</p>
            </div>
          </div>
          <div className="col-md-4">
            <i className="fa fa-shield"></i>
            <div className="service-desc">
              <h3>Quality Assurance</h3>
              <p>We connect you with trusted manufacturers and suppliers for top-quality materials.</p>
            </div>
          </div>
          <div className="col-md-4">
            <i className="fa fa-phone"></i>
            <div className="service-desc">
              <h3>Dedicated Customer Support</h3>
              <p>Get assistance before, during, and after delivery for a smooth experience.</p>
            </div>
          </div>
          <div className="col-md-4">
            <i className="fa fa-road"></i>
            <div className="service-desc">
              <h3>End-to-End Logistics Handling</h3>
              <p>We manage transport, tracking, and coordination so you don’t have to.</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
